import { render } from "./InvoiceDetail.vue?vue&type=template&id=5a0ed02c&scoped=true"
import script from "./InvoiceDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceDetail.vue?vue&type=script&lang=js"

import "./InvoiceDetail.vue?vue&type=style&index=0&id=5a0ed02c&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0ed02c"]])

export default __exports__